module.exports = __webpack_public_path__ + "img/HY3702-193.8de8afcc.jpg";